import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

const state = {
  sbWorkgroups: []
};

export default state



// WEBPACK FOOTER //
// ./src/store/modules/shiftboard/states.js